import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  CheckCircleOutlined,
  ReloadOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import "./styles/StormOps.css";

const API_BASE = process.env.REACT_APP_API_URL || "https://api.fans.nextremedy.net";

export default function StormOpsPublicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadPage = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE}/api/stormops/public/${slug}`);
      const payload = await response.json();

      if (!response.ok || !payload.success) {
        throw new Error(payload.error || "Page not found");
      }

      setPage(payload.data.publicPage);
    } catch (err) {
      setError(err.message || "Unable to load page");
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    loadPage();
  }, [loadPage]);

  return (
    <main className="storm-public-shell">
      <header className="storm-public-nav">
        <Link className="storm-brand" to="/">
          <span className="storm-brand-mark">S</span>
          <span>StormOps Dispatch</span>
        </Link>
        <button className="storm-icon-button" type="button" onClick={loadPage} aria-label="Refresh status">
          <ReloadOutlined />
        </button>
      </header>

      {loading ? (
        <section className="storm-public-state">
          <SafetyOutlined />
          <p>Loading status</p>
        </section>
      ) : error ? (
        <section className="storm-public-state storm-public-error">
          <SafetyOutlined />
          <h1>Status page unavailable</h1>
          <p>{error}</p>
        </section>
      ) : (
        <section className="storm-public-page">
          <div className="storm-public-header">
            <span className={`storm-status storm-status-${page.status || "standby"}`}>{page.status || "standby"}</span>
            <h1>{page.title}</h1>
            <p>{page.notice}</p>
            <div className="storm-source-line">{page.sourceLabel}</div>
          </div>

          <div className="storm-public-grid">
            <section>
              <h2>Current service plan</h2>
              <ul className="storm-check-list">
                {(page.checklist || []).map((item) => (
                  <li key={item}>
                    <CheckCircleOutlined />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section>
              <h2>Request priority</h2>
              <div className="storm-segment-list">
                {(page.serviceSegments || []).map((segment) => (
                  <article key={segment.name}>
                    <strong>{segment.name}</strong>
                    <span>{segment.action}</span>
                  </article>
                ))}
              </div>
            </section>
          </div>

          <footer className="storm-public-footer">
            <span>{page.location}</span>
            <span>{page.nextUpdateRule}</span>
          </footer>
        </section>
      )}
    </main>
  );
}
